import { Component, Input, OnChanges, SimpleChanges } from '@angular/core'
import { Store } from '@ngrx/store'
import { combineLatest, map, Observable } from 'rxjs'
import { ScopeVersion } from '@app/core/model/scope-version'
import { ChangeRequest } from '@app/core/model/change-request.model'
import { CdnConfig } from '@app/core/model/cdn-config.model'
import { ScopeElementsService } from '@app/shared/components/scope-elements/services/scope-elements.service'
import { ScopeOverviewSelectors } from '@app/features/scope-overview/store/selectors/scope-overview.selector'
import { ScopeActions } from '@app/features/scoping/store/actions/scoping.actions'
import { ScopeSection } from '@app/features/scope-overview/model/scope-section'
import { Deliverable } from '@app/features/scoping/models/deliverable.model'
import { plainToInstance } from 'class-transformer'
import { ChangeRequestActions } from '../../store/actions/change-request.actions'
import { ChangeRequestSelectors } from '../../store/selectors/change-request.selectors'

@Component({
  selector: 'change-request-list',
  templateUrl: './change-request-list.component.html',
  styleUrls: ['./change-request-list.component.scss'],
})
export class ChangeRequestListComponent implements OnChanges {
  @Input() currentScope: ScopeVersion
  @Input() currentChangeRequest: ChangeRequest
  @Input() cdnConfig: CdnConfig
  @Input() sections: ScopeSection[]

  @Input() mainColumnClass: string
  @Input() componentMainColumnClass: string
  @Input() roleMainColumnClass: string

  netChangesDeliverables$: Observable<Deliverable[]> = this.store$.select(
    ChangeRequestSelectors.selectNetChangesDeliverables
  )
  netChangesScopeVersion$: Observable<ScopeVersion>

  constructor(
    private store$: Store,
    protected scopeElementsService: ScopeElementsService
  ) {
    this.netChangesScopeVersion$ = combineLatest([
      this.store$.select(ScopeOverviewSelectors.selectCurrentScope),
      this.store$.select(ChangeRequestSelectors.selectNetChangesScope),
    ]).pipe(
      map(([currentScope, netChangesScope]) => {
        if (!currentScope || !netChangesScope?.calculatedValues) return null
        return plainToInstance(ScopeVersion, {
          ...currentScope,
          calculatedValues: netChangesScope.calculatedValues,
        })
      })
    )
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.currentScope?.previousValue?.identity?.id !== this.currentScope?.identity?.id && this.currentScope) {
      this.store$.dispatch(ScopeActions.getAllFeeItems())
    }

    if (changes.currentChangeRequest && this.currentChangeRequest) {
      this.loadNetChanges()
    }
  }

  private loadNetChanges(): void {
    if (this.currentScope?.identity?.id && this.currentChangeRequest?.id) {
      this.store$.dispatch(
        ChangeRequestActions.getNetChanges({
          scopeId: this.currentScope.identity.id,
          changeRequestId: this.currentChangeRequest.id,
        })
      )
    }
  }
}
